import React from 'react';
import { SizeSpacingPanel, ColorsFontsPanel } from '../common/BlockStyleSettings';
import { BLOCK_FEATURES } from '../common/commonDefaults';
import LinkInput from '../common/LinkInput';

/**
 * ButtonCtaEditor - Editor component for button-cta block
 */
const ButtonCtaEditor = ({ block, onChange, theme, hideStylePanels, pages }) => {
  const { content } = block;

  const handleChange = (field, value) => {
    onChange({ [field]: value });
  };

  const handleStyleChange = (styleUpdates) => {
    onChange({ style: { ...(content.style || {}), ...styleUpdates } });
  };

  const features = BLOCK_FEATURES['button-cta'];

  return (
    <div className="space-y-4">
      {/* Heading */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-1">
          Heading (optional)
        </label>
        <input
          type="text"
          value={content.heading || ''}
          onChange={(e) => handleChange('heading', e.target.value)}
          placeholder="Ready to get started?"
          className="w-full px-3 py-2 bg-[#1a1a2e] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:border-[#749555] focus:outline-none"
        />
      </div>

      {/* Subheading */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-1">
          Subheading (optional)
        </label>
        <input
          type="text"
          value={content.subheading || ''}
          onChange={(e) => handleChange('subheading', e.target.value)}
          placeholder="Join thousands of users..."
          className="w-full px-3 py-2 bg-[#1a1a2e] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:border-[#749555] focus:outline-none"
        />
      </div>

      {/* Button Text */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-1">
          Button Text
        </label>
        <input
          type="text"
          value={content.buttonText || ''}
          onChange={(e) => handleChange('buttonText', e.target.value)}
          placeholder="Get Started"
          className="w-full px-3 py-2 bg-[#1a1a2e] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:border-[#749555] focus:outline-none"
        />
      </div>

      {/* Button Link */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-1">
          Button Link
        </label>
        <LinkInput
          value={content.buttonLink || ''}
          onChange={(val) => handleChange('buttonLink', val)}
          pages={pages}
        />
      </div>

      {/* Size (structural — stays inline) */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-1">
          Size
        </label>
        <div className="flex gap-2">
          {[
            { value: 'medium', label: 'Medium' },
            { value: 'large', label: 'Large' },
          ].map((option) => (
            <button
              key={option.value}
              onClick={() => handleChange('size', option.value)}
              className={`flex-1 py-2 px-3 rounded-lg text-sm font-medium transition-colors ${
                content.size === option.value
                  ? 'bg-[#749555] text-white'
                  : 'bg-[#1a1a2e] text-gray-400 hover:text-white border border-gray-700'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {/* Style Panels */}
      {!hideStylePanels && (<>
      <SizeSpacingPanel
        style={content.style || {}}
        onChange={handleStyleChange}
        features={features}
      />
      <ColorsFontsPanel
        style={content.style || {}}
        onChange={handleStyleChange}
        features={features}
        theme={theme || {}}
        blockType="button-cta"
      />
      </>)}
    </div>
  );
};

export default ButtonCtaEditor;
